import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "form__description" }
const _hoisted_4 = {
  key: 1,
  class: "form__success"
}
const _hoisted_5 = { class: "form__actions" }
const _hoisted_6 = ["disabled"]

import Card from '@/components/layout/Card.vue';
import BackLinkTitle from '@/components/layout/BackLinkTitle.vue';
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue';
import FormErrorsList from '@/components/forms/FormErrorsList.vue';
import FormFiles from '@/components/forms/FormFiles.vue';
import {useI18n} from "vue3-i18n";
import {ref} from "vue";
import {useActivityService} from "@/inversify.config";
import {notifyError, notifySuccess} from "@/notify";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminActivityImport',
  setup(__props) {

const {t} = useI18n();
const activityService = useActivityService();

const selectedFile = ref<File | null>(null);
const fileInputKey = ref(0);
const isImporting = ref(false);
const importErrors = ref<string[]>([]);
const successMessage = ref("");

function onFileSelected(files: File | Array<File> | undefined) {
  const file = Array.isArray(files) ? files[0] : files;
  selectedFile.value = file ?? null;
  importErrors.value = [];
  successMessage.value = "";
}

async function submit() {
  if (!selectedFile.value) {
    notifyError(t('activities.import.noFile'));
    return;
  }

  isImporting.value = true;
  importErrors.value = [];
  successMessage.value = "";

  try {
    const result = await activityService.importActivities(selectedFile.value);
    if (result?.success) {
      successMessage.value = t('activities.import.success', {count: result.importedCount});
      notifySuccess(t('activities.import.successTitle'));
      // Reset the file picker so an accidental second click cannot re-import the same activities.
      selectedFile.value = null;
      fileInputKey.value++;
    } else {
      const errors = (result?.errors ?? []).map(error => error.description);
      importErrors.value = errors.length > 0 ? errors : [t('activities.import.genericError')];
      notifyError(t('activities.import.errorTitle'));
    }
  } catch {
    importErrors.value = [t('activities.import.genericError')];
    notifyError(t('activities.import.genericError'));
  } finally {
    isImporting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)('routes.admin.children.activities.import.name')
    }, null, 8, ["title"]),
    _createVNode(BackLinkTitle, {
      title: _unref(t)('routes.admin.children.activities.import.name')
    }, null, 8, ["title"]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('activities.import.description')), 1),
          (_openBlock(), _createBlock(FormFiles, {
            key: fileInputKey.value,
            name: "activities-import-file",
            label: _unref(t)('activities.import.fileLabel'),
            modelValue: selectedFile.value,
            "onUpdate:modelValue": onFileSelected
          }, null, 8, ["label", "modelValue"])),
          (importErrors.value.length > 0)
            ? (_openBlock(), _createBlock(FormErrorsList, {
                key: 0,
                title: _unref(t)('activities.import.errorTitle'),
                errorsList: importErrors.value
              }, null, 8, ["title", "errorsList"]))
            : _createCommentVNode("", true),
          (successMessage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(successMessage.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn",
              disabled: !selectedFile.value || isImporting.value,
              onClick: submit
            }, _toDisplayString(isImporting.value ? _unref(t)('activities.import.importing') : _unref(t)('activities.import.submit')), 9, _hoisted_6)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})